import { useState } from 'react'
import { useMissingPlannings } from '@/api/queries'
import { IssuesPie, type PieSlice } from '@/components/charts/IssuesPie'
import { Widget } from '@/components/ui/Widget'
import { colors } from '@/lib/colors'
import { MissingPlanningsDialog } from './MissingPlanningsDialog'

/** Issues that need a human: synchronisations whose planning was never built. */
export function RateScreenerIssuesWidget({ className }: { className?: string }) {
  const { data, isLoading, error } = useMissingPlannings()
  const [open, setOpen] = useState(false)

  const slices: PieSlice[] = []
  if (error) slices.push({ name: 'Plannings · unavailable', value: 1, color: colors.neutral, label: '' })
  else if (data && data.length > 0) slices.push({ name: 'Missing plannings', value: data.length, color: colors.warn })

  return (
    <Widget title="RateScreener issues" loading={isLoading} className={className}>
      <IssuesPie slices={slices} onSelect={() => setOpen(true)} />
      {open && <MissingPlanningsDialog onClose={() => setOpen(false)} />}
    </Widget>
  )
}
